export enum BodyContentType {
  text = "text",
  chip = "chip",
  link = "link",
  svg = "svg",
  userProfileInfo = "userProfileInfo",
  external = "external",
}

export enum ChipType {
  gray = "gray",
  success = "success",
  warning = "warning",
  error = "error",
  primary = "primary",
  secondary = "secondary",
  draft = "draft",
}

export interface TableData {
  heading: {
    title: string;
    colClass?: string;
    sort?: boolean;
  }[];
  body: (
    | {
        type: BodyContentType.text;
        text: string;
      }
    | {
        type: BodyContentType.link;
        text: string;
        navigationLink: string[];
        icon?: string;
        queryParams?: any;
        cls?: string;
      }
    | {
        type: BodyContentType.chip;
        style: ChipType;
        text: string;
        infoText?: string;
      }
    | {
        type: BodyContentType.svg;
        svg: string;
        width: string;
        height: string;
        actions?: any[];
      }
    | {
        type: BodyContentType.userProfileInfo;
        text: string;
        InfoIcon: string;
        width: string;
        height: string;
        profileIcon?: string;
        id?: string;
        user?: any;
      }
  )[][];
  actions?: {
    label: string;
    icon: string;
    iconColor?: string;
    textColor?: string;
    imageUrl?: string;
    // renderItem?: (item: {label:string,icon:string}) => boolean;
    renderItem?: (item: any) => boolean;
  }[];
}
